import { Sprite, Texture } from "pixi.js";
import { wavelengthToColor } from "../elements/wavelengthColor";

// Builds a continuous-spectrum strip the full width of the stage.
// Same wavelength→color mapping the lines use (400..700 nm linear → [0,1] X).
// NOT bloomed, so it reads as a steady colourful backdrop.
// alpha is tunable via the debug panel (onSpectrumBrightness).
export const SPECTRUM_BG_ALPHA_DEFAULT = 0.21;

export function createSpectrumBackground(width: number, height: number): Sprite {
  const TEX_W = 1024;
  const canvas = document.createElement("canvas");
  canvas.width = TEX_W;
  canvas.height = 1;
  const ctx = canvas.getContext("2d")!;
  const img = ctx.createImageData(TEX_W, 1);
  for (let x = 0; x < TEX_W; x++) {
    // Match the line X mapping: x = ((wl-400)/300) * width.
    const wlNm = 400 + (x / TEX_W) * 300;
    const rgb = wavelengthToColor(wlNm);
    const i = x * 4;
    img.data[i + 0] = (rgb >> 16) & 0xff;
    img.data[i + 1] = (rgb >> 8) & 0xff;
    img.data[i + 2] = rgb & 0xff;
    img.data[i + 3] = 255;
  }
  ctx.putImageData(img, 0, 0);

  const tex = Texture.from(canvas);
  const sprite = new Sprite(tex);
  sprite.width = width;
  sprite.height = height;
  sprite.x = 0;
  sprite.y = 0;
  sprite.alpha = SPECTRUM_BG_ALPHA_DEFAULT;
  sprite.blendMode = "normal";
  return sprite;
}
